// src/constants/lifestyle.js
// New file: Centralizes lifestyle & house-rules options.

import privacyIcon from '../assets/privacy.png';
import cleanIcon from '../assets/clean.png';
import tidyIcon from '../assets/tidy.png';
import respectSpaceIcon from '../assets/respectspace.png';
import cookCleanIcon from '../assets/cookclean.png';
import moneyIcon from '../assets/money.png';
import quietIcon from '../assets/quiet.png';
import commIcon from '../assets/comm.png';
import noSmokeIcon from '../assets/nosmoke.png';
import petIcon from '../assets/pet.png';
import visitsIcon from '../assets/visits.png';
import share_cleaningIcon from '../assets/share_cleaning.png';


export const lifestyleOptions = [
  { value: 'respects_privacy', icon: privacyIcon, ar: 'يحترم الخصوصية', en: 'Respects Privacy' },
  { value: 'keeps_shared_clean', icon: cleanIcon, ar: 'يحافظ على نظافة المناطق المشتركة', en: 'Keeps Shared Areas Clean' },
  { value: 'keeps_personal_tidy', icon: tidyIcon, ar: 'يحافظ على مساحته مرتبة', en: 'Keeps Their Personal Space Tidy' },
  { value: 'respects_personal_space', icon: respectSpaceIcon, ar: 'يحترم المساحة الشخصية', en: 'Respects Personal Space' },
  { value: 'cleans_after_cooking', icon: cookCleanIcon, ar: 'ينظف بعد الطبخ', en: 'Cleans Up After Cooking' },
  { value: 'pays_rent_on_time', icon: moneyIcon, ar: 'يدفع الإيجار في الميعاد', en: 'Pays rent on Time' },
  { value: 'quiet_home', icon: quietIcon, ar: 'يحافظ على منزل هادئ', en: 'Maintains a Quiet Home' },
  { value: 'easy_communication', icon: commIcon, ar: 'سهل التواصل معه', en: 'Easy to Communicate with' },
  { value: 'smoke_allowed', icon: noSmokeIcon, ar: 'لا يمانع التدخين', en: 'Comfortable with Smoking' },
  { value: 'pets_allowed', icon: petIcon, ar: 'لا يمانع العيش مع حيوانات أليفة', en: 'Comfortable Living with Pets' },
  { value: 'dont_mind_visits', icon: visitsIcon, ar: 'لا يمانع زيارات الضيوف', en: "Don't mind Guest Visits" },
   { value: 'share_cleaning', icon: share_cleaningIcon, ar: 'يشارك في أعمال التنظيف', en: "Shares Cleaning Duties" }
];